import React from 'react';
import { getTranslation } from '../../lang/main';
import { CardElement } from 'react-stripe-elements';
import LocalizedMessage from 'react-l10n';
import { isEmpty } from 'validator';
import PropTypes from 'prop-types';

const creditCardOptions = () => {
    return {
        style: {
            base: {
                color: '#000',
                height: 50,
                '::placeholder': {
                    color: '#aab7c4',
                },
            },
            invalid: {
                color: '#c23d4b',
            },
        },
    };
};

class StripeCreditCardFormFields extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            displayError: false,
            hasError: false,
            hasSuccess: false,
            isFocused: false,
            isFilled: false,
            alertMessage: '',
        };
    }
    // `handleClasses` handles all the default classes that can be used to changed the fields style
    handleClasses() {
        const {
            className,
            checked,
            inline,
            big,
            isDisabled,
            isLoading,
        } = this.props;
        const { isFocused, isFilled, hasError, hasSuccess } = this.state;
        let classes = 'field';

        if (inline) {
            classes = classes.concat(' field--inline');
        }
        if (checked) {
            classes = classes.concat(' field--checked');
        }
        if (big) {
            classes = classes.concat(' field--big');
        }
        if (hasError) {
            classes = classes.concat(' field--alert');
        }
        if (hasSuccess) {
            classes = classes.concat(' field--success');
        }
        if (isFocused) {
            classes = classes.concat(' field--focus');
        }
        if (!isEmpty(String(this.props.value))) {
            classes = classes.concat(' field--filled');
        }
        if (isDisabled || isLoading) {
            classes = classes.concat(' field--disabled');
        }
        if (isLoading) {
            classes = classes.concat(' field--loading');
        }
        if (className) {
            classes = classes.concat(` ${className}`);
        }

        return classes;
    }
    onFocus = (e) => {
        this.setState({
            isFocused: true,
        });
    };
    onBlur = (e) => {
        this.setState({
            isFocused: false,
        });
    };
    onChange = (e) => {
        const { error, complete } = e;
        const { setIsCreditCardValidated } = this.props;
        const hasError = typeof error != 'undefined';

        this.setState({
            hasSuccess: complete,
            hasError: hasError,
            displayError: hasError,
            alertMessage:
                typeof error != 'undefined' &&
                typeof error.message != 'undefined'
                    ? error.message
                    : '',
        });

        if (setIsCreditCardValidated) {
            setIsCreditCardValidated(complete);
        }
    };
    // render
    renderError() {
        const { displayError, alertMessage } = this.state;
        if (!displayError) return null;
        return (
            <span className='field__alert' style={{ display: 'block' }}>
                {alertMessage}
            </span>
        );
    }
    render() {
        return (
            <React.Fragment>
                <div
                    className={this.handleClasses()}
                    data-label={getTranslation('FIELD.CREDIT_CARD_INFORMATION')}
                >
                    <span className='field__text'>
                        <LocalizedMessage
                            id={'FIELD.CREDIT_CARD_INFORMATION'}
                        />
                    </span>
                    <div className='field__input' style={{ paddingTop: 17.5 }}>
                        <CardElement
                            id="stripe-creditcard-field"
                            hidePostalCode={true}
                            onChange={this.onChange}
                            onFocus={this.onFocus}
                            onBlur={this.onBlur}
                            {...creditCardOptions()}
                        />
                    </div>
                    {this.renderError()}
                </div>
            </React.Fragment>
        );
    }
}

export default StripeCreditCardFormFields;
